var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostStats({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.04858 12.8115L7.95556 9.05307L11.2598 11.6424L14.099 7.9903",
    stroke: "#778797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.413 4.43475C18.4405 4.43475 19.2734 3.60421 19.2734 2.57968C19.2734 1.55515 18.4405 0.724609 17.413 0.724609C16.3854 0.724609 15.5525 1.55515 15.5525 2.57968C15.5525 3.60421 16.3854 4.43475 17.413 4.43475Z",
    stroke: "#778797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4904 1.51691H5.45549C2.54852 1.51691 0.726807 3.58456 0.726807 6.49278V14.2995C0.726807 17.198 2.50007 19.256 5.45549 19.256H13.7888C16.6958 19.256 18.5175 17.2077 18.5175 14.2995V7.53621",
    stroke: "#778797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostStats);
export default __webpack_public_path__ + "static/media/post_stats.07f06df633d761c5fd8da67c0a08946c.svg";
export { ForwardRef as ReactComponent };